import wellKnownSymbol$1 from './well-known-symbol.js';

var wellKnownSymbol = wellKnownSymbol$1;
var MATCH = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;

  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) {
      /* empty */
    }
  }

  return false;
};

export { correctIsRegexpLogic as default };
